import { render, staticRenderFns } from "./ListPreview.vue?vue&type=template&id=f2464ea0"
import script from "./ListPreview.vue?vue&type=script&lang=ts"
export * from "./ListPreview.vue?vue&type=script&lang=ts"
import style0 from "./ListPreview.vue?vue&type=style&index=0&id=f2464ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports